import React, { useState, lazy, Suspense } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const MainCalculatorsList = React.lazy(() => import("./MainCalculators"));
const RelatedLinks = React.lazy(() => import("../RelatedLinks"));

const TITLE = "Kalkulator Durasi Kematian dalam Masehi - Hitung Berapa Lama Telah Berlalu Sejak Kematian dengan Akurat";
const DESCRIPTION =
  "Gunakan kalkulator durasi kematian yang akurat dalam Masehi untuk mengetahui periode waktu lengkap yang telah berlalu sejak tanggal kematian, dirinci dalam tahun, bulan, hari, jam, menit, dan detik. Alat gratis dan mudah digunakan untuk menghitung durasi sejak meninggalnya seseorang yang tercinta.";
const KEYWORDS =
  "kalkulator durasi kematian, berapa lama telah berlalu sejak kematian, tanggal kematian dalam masehi, perhitungan periode setelah kematian, durasi waktu kematian, kematian seseorang yang tercinta, menentukan durasi kematian, kalkulator gratis untuk kematian, perhitungan hari sejak kematian, perhitungan bulan sejak kematian, perhitungan tahun sejak kematian";
const OG_URL = "https://do-calculate.com/calculator/id/duration-since-death/";

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April",
  "Mei", "Juni", "Juli", "Agustus",
  "September", "Oktober", "November", "Desember"
];

function DurationSinceDeathCalculatorGregorian() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);

  // Mengganti kolom teks dengan objek tanggal
  const [deathDateInput, setDeathDateInput] = useState({
    day: "1",
    month: "1",
    year: "2020"
  });

  const [durationGregorian, setDurationGregorian] = useState(null);

  const calculateDurationGregorian = async () => {
    setIsLoading(true);
    setError(null);
    setDurationGregorian(null);

    try {
      // Membangun tanggal dari dropdown
      const deathDate = new Date(
        parseInt(deathDateInput.year),
        parseInt(deathDateInput.month) - 1,
        parseInt(deathDateInput.day)
      );

      const now = new Date();
      if (isNaN(deathDate.getTime()) || deathDate > now) {
        setError("Tanggal kematian tidak valid atau berada di masa depan.");
        setIsLoading(false);
        setStatusCode(400);
        return;
      }

      let diffMs = now - deathDate;
      const totalSeconds = Math.floor(diffMs / 1000);
      const remainingSeconds = totalSeconds % 60;
      const totalMinutes = Math.floor(totalSeconds / 60);
      const remainingMinutes = totalMinutes % 60;
      const totalHours = Math.floor(totalMinutes / 60);
      const remainingHours = totalHours % 24;

      let years = 0;
      let months = 0;
      let tempDate = new Date(deathDate.getTime());

      while (tempDate < now) {
        let nextMonth = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, tempDate.getDate());
        if (nextMonth <= now) {
          months++;
          tempDate = nextMonth;
        } else {
          break;
        }
      }

      years = Math.floor(months / 12);
      months = months % 12;
      let remainingDays = Math.floor((now - tempDate) / (1000 * 60 * 60 * 24));

      setDurationGregorian({
        years,
        months,
        days: remainingDays,
        hours: remainingHours,
        minutes: remainingMinutes,
        seconds: remainingSeconds,
      });
      setStatusCode(200);
    } catch (err) {
      console.error(err);
      setError("Terjadi kesalahan saat menghitung durasi.");
      setStatusCode(500);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8" >
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px", lineHeight: "50px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light p-3">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini membantu Anda menentukan <strong>periode waktu yang telah berlalu sejak tanggal kematian seseorang</strong>, menggunakan <strong>kalender Masehi</strong>. Baik Anda ingin melacak durasi untuk peringatan tahunan, atau untuk tujuan statistik, atau sekadar rasa ingin tahu, alat ini memberi Anda perhitungan yang akurat. Anda dapat memasukkan tanggal kematian dengan tepat, dan kalkulator akan menampilkan durasi secara detail: <strong>dalam tahun, bulan, hari, jam, menit, dan detik</strong> hingga saat ini.
                </p>
                <p>
                  <strong>Menghitung durasi kematian</strong> tidak pernah semudah ini. <strong>Kalkulator gratis ini</strong> dirancang untuk mudah digunakan dan memberikan hasil instan. Yang perlu Anda lakukan adalah memasukkan tanggal kematian yang diinginkan di kolom yang disediakan, lalu tekan tombol "Hitung Durasi". Anda akan mendapatkan rincian lengkap durasi yang telah berlalu, memberi Anda gambaran yang jelas tentang periode waktu dengan akurasi tinggi. Mulai sekarang dan ketahui <strong>berapa lama telah berlalu sejak kematian</strong>!
                </p>
                <br />
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-3">
              <div className="p-3 mb-2 bg-success text-white text-center rounded">
                <h1 style={{ fontSize: "20px", margin: 0 }}>Kalkulator Durasi Sejak Kematian</h1>
              </div>
              <div className="col-12 col-md-4" >
                <label style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Masukkan Tanggal Kematian dalam Kalender Masehi
                </label>
              </div>
              <div className="row">

                <div className="col-12 col-md-8 text-center mb-3">
                  <div className="d-flex gap-2">
                    {/* Dropdown hari */}
                    <select
                      className="form-control"
                      value={deathDateInput.day}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, day: e.target.value })}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>

                    {/* Dropdown bulan */}
                    <select
                      className="form-control"
                      value={deathDateInput.month}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, month: e.target.value })}
                    >
                      {GREGORIAN_MONTHS.map((m, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                      ))}
                    </select>

                    {/* Dropdown tahun */}
                    <select
                      className="form-control"
                      value={deathDateInput.year}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, year: e.target.value })}
                    >
                      {Array.from({ length: 120 }, (_, i) => new Date().getFullYear() - i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col text-center">
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={calculateDurationGregorian}
                    disabled={isLoading}
                  >
                    {isLoading ? "Menghitung..." : "Hitung Durasi"}
                  </button>
                  <br />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col">
                  <br />
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u> Terjadi Kesalahan :</u>
                      </b>{" "}
                      {error || "Harap masukkan tanggal kematian yang valid."}
                    </div>
                  )}
                  {durationGregorian && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <label>
                          <strong>Durasi yang Telah Berlalu:</strong>{" "}
                          {durationGregorian.years} tahun {durationGregorian.months} bulan {durationGregorian.days} hari {durationGregorian.hours} jam {durationGregorian.minutes} menit {durationGregorian.seconds} detik
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <Suspense fallback={<div>Memuat...</div>}>
              <RelatedLinks />
            </Suspense>
            <br />
            <hr />
          </div>
        </div>
        <div className="col-12 col-md-4">
          <SecondAds />
          <br />
          <Suspense fallback={<div>Memuat...</div>}>
            <MainCalculatorsList />
          </Suspense>
          <br />
        </div>
      </div>
    </div>
  );
}

export default DurationSinceDeathCalculatorGregorian;